import { throttle } from "lodash";

class Header {
  stateClasses = {
    expanded: 'header--expanded',
  };

  constructor($el) {
    this.$el = $el;
    this.$window = $(window);
    this.init();
  }

  init = () => {
    // bind scroll event
    this.$window.on('scroll', throttle(this.handleScroll, 200));
  };

  handleScroll = (e) => {
    // scroll position
    const scrollTop = this.$window.scrollTop();

    if (scrollTop > 0) {
      this.$el.removeClass(this.stateClasses.expanded);
    } else {
      this.$el.addClass(this.stateClasses.expanded);
    }
  };

}

export default Header;